import { RewardPill } from './RewardPill';

export interface MysteryQuestCardProps {
  /** t('ec2.quest.mystery.title') — `Hidden quests are everywhere`. */
  title: string;
  /** t('ec2.quest.mystery.caption') — `Found a QR somewhere? Scan it.` */
  caption: string;
  /** Accessible name for the gold `?` pill — t('ec2.a11y.mysteryReward'). */
  rewardLabel: string;
  /** Opens the scanner. */
  onClick: () => void;
  className?: string;
}

/**
 * The permanent mystery quest placeholder (spec §1.2 / brief §6): dashed 1.5px
 * border, no fill, `?` chip in --fg-muted on a neutral 8% tint, gold `?` reward
 * pill. Always last in Open/All; never completes, never counts.
 */
export function MysteryQuestCard({ title, caption, rewardLabel, onClick, className = '' }: MysteryQuestCardProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="ec-mystery-card"
      className={
        `w-full rounded-(--radius-card) border-[1.5px] border-dashed border-border bg-transparent p-4 text-left ` +
        `focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary ${className}`
      }
    >
      <div className="flex items-start gap-3">
        <span
          aria-hidden
          className="flex size-10 shrink-0 items-center justify-center rounded-(--radius-chip) bg-fg/8 font-display text-lg font-[650] text-fg-muted"
        >
          ?
        </span>
        <div className="min-w-0 flex-1">
          <h3 className="font-display text-[21px] leading-[1.25] font-[650] text-fg">{title}</h3>
          <p className="mt-0.5 text-[13px] font-medium text-fg-secondary">{caption}</p>
        </div>
      </div>
      <div className="mt-3 flex justify-end">
        <RewardPill mystery label={rewardLabel} />
      </div>
    </button>
  );
}
